import { Flex, Loader } from "monday-ui-react-core";

interface Props {
  label?: string;
}

export function LoadingPage({ label }: Props) {
  return (
    <Flex
      direction={Flex.directions.COLUMN}
      align={Flex.align.CENTER}
      justify={Flex.justify.CENTER}
      // style={{ width: "100vw", height: "100vh" }}
    >
      <Loader size={Loader.sizes.MEDIUM} />
      <>{label && <p>{label}</p>}</>
    </Flex>
  );
}
